module.exports = __webpack_public_path__ + "static/media/1POLICY10.0c2a5500.jpg";